export default __webpack_public_path__ + "static/media/slide1.a617f7d3.jpg";